/* Shelter configurator
   Reads product.metafields.custom.product_options and drives:
   live price, conditional groups, validation, multi-line add to cart.
   Paid choices carry addon_variant_id so the cart charge always
   matches the price shown on the page. */
(function () {
  'use strict';

  function init(root) {
    var configEl = root.querySelector('[data-sc-config]');
    if (!configEl) return;

    var config;
    try { config = JSON.parse(configEl.textContent); } catch (e) { return; }
    if (!config || !config.options) return;

    var basePrice = parseInt(root.dataset.basePrice, 10) || 0;
    var baseVariant = root.dataset.baseVariant;
    var baseLabel = root.dataset.baseLabel || 'Shelter';
    var format = root.dataset.moneyFormat || '\u00a3{{amount}}';

    var linesEl = root.querySelector('[data-sc-lines]');
    var totalEl = root.querySelector('[data-sc-total]');
    var qtyEl = root.querySelector('[data-sc-qty]');
    var msgEl = root.querySelector('[data-sc-message]');
    var submitEl = root.querySelector('[data-sc-submit]');

    var selections = {};

    function money(pence) {
      var n = (pence / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return format.replace(/\{\{\s*amount[^}]*\}\}/, n).replace(/<[^>]*>/g, '');
    }

    function visible(opt) {
      if (!opt.show_when) return true;
      var current = selections[opt.show_when.option_id];
      if (!current) return false;
      var values = opt.show_when.values || [];
      return values.indexOf(current.label) !== -1;
    }

    function groupEl(id) {
      return root.querySelector('[data-sc-group="' + id + '"]');
    }

    function syncVisibility() {
      config.options.forEach(function (opt) {
        var el = groupEl(opt.id);
        if (!el) return;
        var show = visible(opt);
        el.hidden = !show;
        if (!show && selections[opt.id]) {
          delete selections[opt.id];
          Array.prototype.forEach.call(el.querySelectorAll('input:checked'), function (i) { i.checked = false; });
          Array.prototype.forEach.call(el.querySelectorAll('select'), function (s) { s.value = ''; });
        }
      });
    }

    function render() {
      var rows = [{ label: baseLabel, value: money(basePrice) }];
      var total = basePrice;

      config.options.forEach(function (opt) {
        if (!visible(opt)) return;
        var sel = selections[opt.id];
        if (!sel) return;
        total += sel.price;
        rows.push({
          label: opt.name + ': ' + sel.label,
          value: sel.price > 0 ? '+ ' + money(sel.price) : 'Included'
        });
      });

      linesEl.innerHTML = rows.map(function (r) {
        return '<div class="sc-summary__line"><dt></dt><dd></dd></div>';
      }).join('');

      Array.prototype.forEach.call(linesEl.children, function (node, i) {
        node.querySelector('dt').textContent = rows[i].label;
        node.querySelector('dd').textContent = rows[i].value;
      });

      var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      totalEl.textContent = money(total * qty);
    }

    function findChoice(opt, label) {
      for (var i = 0; i < opt.choices.length; i++) {
        if (opt.choices[i].label === label) return opt.choices[i];
      }
      return null;
    }

    root.addEventListener('change', function (e) {
      var field = e.target;
      if (!field.name || !field.name.indexOf) return;
      var opt = config.options.filter(function (o) { return o.id === field.name; })[0];
      if (!opt) return;

      if (!field.value) {
        delete selections[opt.id];
      } else {
        var choice = findChoice(opt, field.value);
        if (!choice) return;
        selections[opt.id] = {
          label: choice.label,
          price: Math.round((choice.price_add || 0) * 100),
          addonVariantId: choice.addon_variant_id || null
        };
      }
      syncVisibility();
      render();
      message('');
    });

    qtyEl.addEventListener('input', render);

    function message(text) {
      msgEl.textContent = text;
      msgEl.hidden = !text;
    }

    submitEl.addEventListener('click', function () {
      message('');
      var missing = [];
      config.options.forEach(function (opt) {
        if (opt.required && visible(opt) && !selections[opt.id]) missing.push(opt.name);
      });
      if (missing.length) {
        message('Choose an option for: ' + missing.join(', ') + '.');
        var first = groupEl(config.options.filter(function (o) { return o.name === missing[0]; })[0].id);
        if (first) first.scrollIntoView({ block: 'center' });
        return;
      }

      var qty = Math.max(1, parseInt(qtyEl.value, 10) || 1);
      var configId = 'sc-' + Date.now().toString(36) + Math.random().toString(36).slice(2, 7);
      var props = { _config_id: configId };
      var addons = [];
      var broken = [];

      config.options.forEach(function (opt) {
        if (!visible(opt)) return;
        var sel = selections[opt.id];
        props[opt.name] = sel.label;
        if (sel.price > 0) {
          if (!sel.addonVariantId) { broken.push(opt.name); return; }
          addons.push({
            id: sel.addonVariantId,
            quantity: qty,
            properties: { _config_id: configId, _addon_for: opt.name }
          });
        }
      });

      if (broken.length) {
        message('Pricing is not linked for: ' + broken.join(', ') + '. Please contact us to order this combination.');
        return;
      }

      submitEl.disabled = true;
      var original = submitEl.textContent;
      submitEl.textContent = 'Adding\u2026';

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: baseVariant, quantity: qty, properties: props }].concat(addons)
        })
      })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || 'Could not add to basket.');
          window.location.href = '/cart';
        })
        .catch(function (err) {
          message(err.message);
          submitEl.disabled = false;
          submitEl.textContent = original;
        });
    });

    /* Info modal */
    var modal = root.querySelector('[data-sc-modal]');
    if (modal) {
      var body = modal.querySelector('[data-sc-modal-body]');
      root.addEventListener('click', function (e) {
        var trigger = e.target.closest('[data-sc-info]');
        if (trigger) {
          body.textContent = trigger.getAttribute('data-sc-info');
          modal.hidden = false;
          modal.querySelector('[data-sc-modal-close]').focus();
          return;
        }
        if (e.target.closest('[data-sc-modal-close]') || e.target.closest('[data-sc-modal-scrim]')) {
          modal.hidden = true;
        }
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') modal.hidden = true;
      });
    }

    syncVisibility();
    render();
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-shelter-cfg]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
